import React from 'react';
import { Alert, Stack, Typography } from '@mui/material';

type ReportEmptyStateProps = {
  title: string;
  detail?: string;
  missingData?: string[];
  compact?: boolean;
};

const ReportEmptyState: React.FC<ReportEmptyStateProps> = ({
  title,
  detail,
  missingData,
  compact = false,
}) => (
  <Alert severity="info" variant="outlined" sx={{ py: compact ? 0.5 : 1 }}>
    <Stack spacing={compact ? 0.25 : 0.5}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      {detail ? (
        <Typography variant="body2" color="text.secondary">
          {detail}
        </Typography>
      ) : null}
      {missingData && missingData.length > 0 ? (
        <Typography variant="caption" color="text.secondary">
          Missing data: {missingData.join(', ')}
        </Typography>
      ) : null}
    </Stack>
  </Alert>
);

export default ReportEmptyState;
